// state
import { IUserInfoState, initialUserInfoState } from "@store/state/UserInfo";

// actions
import { IUserInfoAction, UserInfoActionType } from "@store/actions/UserInfo";

// helpers
import { createDeepCopy } from "@utils/index";

// Reducer to handle user info state and actions
export const userInfoReducer = (state: IUserInfoState = initialUserInfoState, action: IUserInfoAction): IUserInfoState => {
    switch (action.type) {
        case UserInfoActionType.SET_EMAIL:
        case UserInfoActionType.SET_USERNAME:
        case UserInfoActionType.SET_IS_USER_AUTHORIZED:
        case UserInfoActionType.SET_SELECTED_SANDBOX: {
            // createDeepCopy is used to ensure immutability - creates a completely new object
            // with all nested properties copied, preventing any accidental mutations of the original state
            return createDeepCopy({
                ...state,
                ...action.payload,
                isRFAUser: action.payload.selectedSandbox?.sandbox_name?.toLowerCase().includes("rfa") ?? false,
            });
        }
        case UserInfoActionType.SET_SANDBOXES:
        case UserInfoActionType.SET_USER_INFO:
        case UserInfoActionType.SET_SELECTED_ALLOCATION_TYPE:
        case UserInfoActionType.SET_FEATURE_FLAGS:
            // createDeepCopy ensures immutable state updates even for nested state properties
            return createDeepCopy({
                ...state,
                ...action.payload,
            });
        default:
            return state;
    }
};
